const locale = {
    placeholder: 'Избери време',
    rangePlaceholder: ['Почетно време', 'Крајно време'],
};
export default locale;
